"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendFeedback = sendFeedback;
exports.getLanguage = getLanguage;

var _createForOfIteratorHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/createForOfIteratorHelper"));

function sendFeedback(feedbackData, brand, user, parameters, filename) {
  var timestamp = Date.now();
  var file_id = filename || (String(timestamp) + '_' + user).replace(":", "-");
  feedbackData['id'] = file_id;
  feedbackData['timestamp'] = timestamp;
  feedbackData['results'] = {
    'transcripts': [{
      'transcript': feedbackData['text']
    }]
  };
  feedbackData['user'] = user;
  feedbackData['Predominant_Sentiment_Comprehend'] = feedbackData['sentiment'];
  delete feedbackData['sentiment'];
  Object.keys(parameters).map(function (x) {
    feedbackData[x] = parameters[x];
  });
  fetch(localStorage.stage == "Dev" ? "https://qqirik9sib.execute-api.eu-west-3.amazonaws.com/Prod/GetPresignedUrl" : 'https://uxyod4ko50.execute-api.eu-west-3.amazonaws.com/Prod/GetPresignedUrl', {
    method: 'POST',
    body: JSON.stringify({
      brand: brand,
      filename: file_id
    })
  }).then(function (x) {
    if (x.status === 400) {
      return x.json().then(console.warn);
    }

    return x.json();
  }).then(function (resp) {
    // Send the file json
    console.warn(JSON.stringify(feedbackData));
    var file = new File([new Blob([JSON.stringify(feedbackData)])], file_id + '.json');
    var formData = new FormData();

    for (var key in resp['metadata_url'].fields) {
      formData.append(key, resp['metadata_url'].fields[key]);
    }

    ;
    formData.append('file', file);
    fetch(resp['metadata_url'].url, {
      method: 'POST',
      body: formData
    }).then(function (x) {
      return console.log('Metadata status : ', x.status);
    });
  });
  return file_id;
}

function getLanguage(dict) {
  if (typeof dict === "string") {
    return dict;
  }

  var lgs = navigator.languages.map(function (x) {
    return x.substring(0, 2);
  });

  var _iterator = (0, _createForOfIteratorHelper2.default)(lgs),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var lg = _step.value;

      if (dict.hasOwnProperty(lg)) {
        return dict[lg];
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return dict[Object.keys(dict)[0]];
}